const formatNumber = (number, decimals) =>
  Number(Number(number ?? 0)?.toFixed(decimals) ?? 0);

// Debounce function to avoid unnecesary calls
function debounce(callback, wait) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

export { formatNumber, debounce };
